(function () {
    'use strict';

    angular
        .module('app.accountProjects', [])
        .controller('accountProjectsCtrl', ['$scope', '$rootScope', 'accountProjectsService', '$stateParams', '$http', '$compile', '$modal', 'advertiserProjectDetailService', 'mentionManagementService',
            function ($scope, $rootScope, accountProjectsService, $stateParams, $http, $compile, $modal, advertiserProjectDetailService, mentionManagementService) {
                var definitions = angular.copy($rootScope.definitions);
                $scope.countries = [];
                angular.forEach(definitions.countries, function(country) {
                    if(country.isActive == 1) {
                        $scope.countries.push(country);
                    }
                })

                $scope.searchCountries = function(event) {
                    if (/[a-zA-Z0-9-_ ]/.test(event.key)) {
                        for(var i = 0; i < $scope.countries.length; i++) {
                            if($scope.countries[i].name.toLowerCase().indexOf(event.key.toLowerCase()) == 0) {
                                var checkbox = $("#selectCountry > .checkboxLayer.show .checkBoxContainer")
                                var item = checkbox.find('label')[i];
                                checkbox.animate({ scrollTop: item.parentElement.parentElement.offsetTop }, { duration: 'medium', easing: 'swing' });
                                break;
                            }
                        }
                    }
                }

                $scope.isNewProject = false;
                $scope.selectDiffProject = false;
                $scope.newProjectId = null;
                $scope.mentionLanguage = 'Choose Language';
                $scope.mentionTopic = 'Choose Topic';
                $scope.mentionIndustry = 'Choose Industry';

                var newTagLabel = "";
                var language_id = null;
                var checkLanguage = -1;
                var closeCountryDropdownList = true;
                var closeProjectDropdownList = true;

                $scope.KeywordValidate = true;
                $scope.existsMentions = [];
                $scope.temporaryMentions = [];
                $scope.topics = [];
                var topicObject = {
                    id: 1,
                    name: "No Topic"
                }
                $scope.topics.push(topicObject);

                $scope.industries = [];
                var industryObject = {
                    id: 1,
                    name: "No Industry"
                }
                $scope.industries.push(industryObject);

                $('#mention-language-dropdown-list').children().eq(0).attr("disabled","disabled");
                $('#mention-topic-dropdown-list').children().eq(0).attr("disabled","disabled");
                $('#mention-industry-dropdown-list').children().eq(0).attr("disabled","disabled");

                $scope.getAccountInformation = function() {
                    accountProjectsService.getAccountInformation($stateParams.account_id, true)
                        .then(function(response) {
                            $scope.accountDetail = response.data;
                            $scope.accountProjects = $scope.accountDetail.company_projects;
                        })
                }

                $scope.getKeywordLanguages = function() {
                    mentionManagementService.getLanguagesOfInterestingCountries(false)
                        .then(function(response) {
                            $scope.languages = response.data;
                        }, function(response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.getKeywordTopics = function() {
                    accountProjectsService.getKeywordTopics(false)
                        .then(function(response) {
                            angular.forEach(response.data, function(item) {
                                $scope.topics.push(item);
                            })
                        })
                }

                $scope.getKeywordIndustries = function() {
                    accountProjectsService.getKeywordIndustries(false)
                        .then(function(response) {
                            angular.forEach(response.data, function(item) {
                                $scope.industries.push(item);
                            })
                        })
                }

                $scope.removeAllInformation = function() {
                    angular.forEach($scope.countries, function(country) {
                        country.ticked = false;
                    });

                    $scope.mentionLanguage = 'Choose Language';
//                    angular.forEach($scope.languages, function(language) {
//                        language.ticked = false;
//                    });

                    $scope.mentionTopic = 'Choose Topic';
//                    angular.forEach($scope.topics, function(topic) {
//                        topic.ticked = false;
//                    });

                    $scope.mentionIndustry = 'Choose Industry';
//                    angular.forEach($scope.industries, function(industry) {
//                        industry.ticked = false;
//                    });

                    $scope.isNewProject = false;
                    $scope.account_project_name = "";

                    $('#projectKeywords').tagit("removeAll");
                    $('#projectUrls').tagit("removeAll");
                    $('#projectHashtags').tagit("removeAll");
                
                    $('#projectKeywords').popover('destroy');
                    $('#projectUrls').popover('destroy');
                    $('#projectHashtags').popover('destroy');
                }

                $scope.handleOnTagClicked = function(project_mentions, tagLabel) {
                    angular.forEach(project_mentions, function(mention) {
                        if(mention.keyword == tagLabel) {
                            if(mention.is_global == 1) {
                                $scope.mentionLanguage = 'Global';
//                                $scope.languages[0].ticked = true;
//                                for(var i = 1; i < $scope.languages.length; i++) {
//                                    $scope.languages[i].ticked = false;
//                                }
                            } else {
                                angular.forEach($scope.languages, function(language) {
//                                  language.ticked = false;
                                    angular.forEach(mention.languages, function(val) {
                                        if(language.id == val) {
//                                          language.ticked = true;
                                            $scope.mentionLanguage = language.name;
                                        }
                                    })
                                })
                            }

                            $scope.mentionTopic = "No Topic";
                            angular.forEach($scope.topics, function(topic) {
                                if(topic.id == mention.topic_id) {
//                                    topic.ticked = true;
                                    $scope.mentionTopic = topic.name;
                                }
//                                else {
//                                    topic.ticked = false;
//                                }
                            })

                            $scope.mentionIndustry = "No Industry";
                            angular.forEach($scope.industries, function(industry) {
                                if(industry.id == mention.vertical_id) {
                                    $scope.mentionIndustry = industry.name;
//                                    industry.ticked = true;
                                }
//                                else {
//                                    industry.ticked = false;
//                                }
                            })
                        }
                    })
                    $scope.$apply();
                }

                $scope.addNewAccountProject = function() {
                    $scope.removeAllInformation();
                    $scope.isNewProject = true;
                }

                $scope.saveAccountProject = function() {
                    if($(".account-keywords-urls-hashtags").find(".unexisting").length > 0) {
                        var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = "There are some New Mentions that does not exist in the system. Please help to create the New Mentions.";
                        event.stopPropagation();
                        return;
                    } 
                    
                    var params = {
                        name: $scope.account_project_name,
                        keywords: $scope.existsMentions,
                        countries: $scope.countryList,
                        advertiserID: $stateParams.account_id
                    }

                    accountProjectsService.saveAccountProject(params, true)
                        .then(function(response) {
                            $scope.removeAllInformation();
                            $scope.getAccountInformation();
                        }, function(response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })                   
                }

                $scope.updateAccountProject = function () {
                    if($(".account-keywords-urls-hashtags").find(".unexisting").length > 0) {
                        var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = "There are some New Mentions that does not exist in the system. Please help to create the New Mentions.";
                        event.stopPropagation();
                        return;
                    } 
                             
                    var params = {
                        id: $scope.project_id,
                        name: $scope.project_name,
                        keywords: $scope.existsMentions,
                        countries: $scope.countryList,
                        advertiserID: $stateParams.account_id
                    }

                    accountProjectsService.updateAccountProject(params, true)
                        .then(function(response) {
                            $scope.removeAllInformation();
                            $scope.getAccountInformation();

                        }, function(response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        });
                }

                $scope.deleteAccountProject = function() {
                    if($scope.project_id == null) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = "Please choose project which you want to delete.";
                        event.stopPropagation();
                        return;
                    }
                    
                    var deleteConfirmModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/project_delete.html?app_v=deployDate'
                    });

                    $scope.project = {
                        name: $scope.project_name
                    }
                    $scope.deleteConfirmModalInstance = deleteConfirmModalInstance;
                }

                $scope.delete = function () {
                    accountProjectsService.deleteAccountProject($scope.project_id, true)
                        .then(function(response) {
                            $scope.deleteConfirmModalInstance.close();
                            $scope.removeAllInformation();
                            $scope.getAccountInformation();
                        }, function(response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                }

                $scope.$watch('selectedCountry', function(newValue, oldValue){
                    $scope.countryList = [];
                    angular.forEach(newValue, function (item) {
                        $scope.countryList.push(item.id);
                    })
                });

                $scope.$watch('selectedProject', function(newValue, oldValue) {
                    if(newValue !== undefined && newValue.length != 0 && newValue !== oldValue) {
                        $scope.removeAllInformation();
                        $scope.project_id = newValue[0].project_id;
                        $scope.project_name = newValue[0].project_name;
                        $scope.project_keywords = newValue[0].project_keywords;  
                        $scope.project_urls = newValue[0].project_urls;
                        $scope.project_hashtags = newValue[0].project_hashtags;
                        $scope.project_countries = newValue[0].project_countries;
                        angular.forEach($scope.countries, function(item) {
                            item.ticked = false;
                            angular.forEach($scope.project_countries, function(country) {
                                if(item.id == country.country_id) {
                                    item.ticked = true;
                                }
                            })
                        })

                        $scope.selectDiffProject = true;
                        $scope.isNewProject = newValue[0].project_id == 0 ? true : false;

                        setTimeout(function () {                   
                            if(!$scope.isNewProject){
                                $scope.project = newValue[0];
                                $scope.KeywordValidate = false;
                                angular.forEach($scope.project.project_keywords, function(mention) {
                                    $("#projectKeywords").tagit({
                                        id: mention.mention_id
                                    });
                                    $("#projectKeywords").tagit("createTag", mention.mention_name);
                                });

                                angular.forEach($scope.project.project_urls, function(mention) {
                                    $("#projectUrls").tagit("createTag", mention.mention_name);
                                });

                                angular.forEach($scope.project.project_hashtags, function(mention) {
                                    $("#projectHashtags").tagit("createTag", mention.mention_name);
                                });

                                $scope.KeywordValidate = true;

                            } else {
                                if(mentions != null) {
                                    $scope.KeywordValidate = false;
                                    var DomainPatter = new RegExp(/^(?!:\/\/)([a-zA-Z0-9]+\.)?[a-zA-Z0-9-]+\.([a-zA-Z]{2,6}|[a-zA-Z]{2,6}.[a-zA-Z]{2,6})?$/i);
                                    mentions.forEach(function(val){
                                        if(val.startsWith("#")){
                                            $("#projectHashtags").tagit("createTag", val);
                                        } else if(DomainPatter.test(val)) {
                                            $("#projectUrls").tagit("createTag", val);
                                        } else {
                                            $("#projectKeywords").tagit("createTag", val);
                                        }
                                    });
                                    $scope.KeywordValidate = true;
                                }
                            }
                        }, 500);
                    }
                })

                $scope.unexistingClick = function(tagToDefine, $event) {
                    var getLanguageByCountryParam = {
                        countries: $scope.countryList
                    }

                    advertiserProjectDetailService.getLanguageByCountry(getLanguageByCountryParam)
                        .then(function(response) {
                            if (response.data.language.length == 1) {
                                language_id = response.data.language[0].id;
                            } else if (response.data.language.length > 1) {
                                language_id = -1;
                            }

                            var unexistingMention = $event.target;
                            var typeid = $event.target.parentElement.parentElement.getAttribute("data-typeid");
                            var tagElement = unexistingMention.parentElement;
                            $rootScope.newMentionModalHandler(tagToDefine, typeid, language_id, function(newMention){
                                if(newMention){
                                    var newSpan = $compile('<span class="txt-waitapprove">+ Wait For Approve&nbsp;</span><img src="/images/question.gif" class="questionMention">')($scope);
                                    $(tagElement).find('.unexisting').remove();
                                    $(tagElement).find('.questionMention').remove();
                                    $(tagElement).append(newSpan);
                                    $scope.existsMentions.push(newMention);
                                } else {
                                    console.log('cancel');
                                }
                                    
                            });
                        }, function(response) {
                            var errorModalInstance = $modal.open({
                                scope: $scope,
                                templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                windowClass: 'modal-dialog-mention-error'
                            });
                            $scope.errorModalInstance = errorModalInstance;
                            $scope.errorMessage = response.message;
                        })
                };

                setTimeout(function () {
                    $(".mentions").tagit({
                        allowDuplicates: false,
                        allowSpaces: true,
                        removeConfirmation: true,
                        caseSensitive: false,
                        // tagLimit: 3,
                        //availableTags: availableTags(),

                        beforeTagAdded: function (event, ui) {
                            var label = encodeURIComponent(ui.tagLabel);
                            var typeid = event.target.getAttribute("data-typeid");
                            if($scope.KeywordValidate){
                                var DomainPatter = new RegExp(/^(?!:\/\/)([a-zA-Z0-9]+\.)?[a-zA-Z0-9-]+\.([a-zA-Z]{2,6}|[a-zA-Z]{2,6}.[a-zA-Z]{2,6})?$/i);
                                if(typeid == 1){
                                    // if(DomainPatter.test(ui.tagLabel) || ui.tagLabel.startsWith("#"))
                                    if ($scope.countryList == [] || $scope.countryList === undefined || $scope.countryList.length == 0) {
                                        $('#projectKeywords').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Please select country first</div>', html: true});
                                        $('#projectKeywords').popover('show');
                                        event.stopPropagation();
                                        return false;
                                    }

                                    if(DomainPatter.test(ui.tagLabel) || ui.tagLabel.indexOf("#") == 0 || ui.tagLabel.split(' ').length >= 3)
                                    {
                                        $('#projectKeywords').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Keyword is not valid,should input only 1 or 2 words and not be URL or Hashtag(#)</div>', html: true});
                                        $('#projectKeywords').popover('show');
                                        event.stopPropagation();
                                        return false;
                                    }
                                    $('#projectKeywords').popover('destroy');
                                } else if(typeid == 2){
                                    if ($scope.countryList == [] || $scope.countryList === undefined || $scope.countryList.length == 0) {
                                        $('#projectUrls').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Please select country first</div>', html: true});
                                        $('#projectUrls').popover('show');
                                        event.stopPropagation();
                                        return false;
                                    }

                                    if(!DomainPatter.test(ui.tagLabel))
                                    {
                                        $('#projectUrls').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Url is not valid - i.e. google.com</div>', html: true});
                                        $('#projectUrls').popover('show');
                                        event.stopPropagation();
                                        return false;
                                    }
                                    $('#projectUrls').popover('destroy');
                                }  else if(typeid == 3){
                                    if ($scope.countryList == [] || $scope.countryList === undefined || $scope.countryList.length == 0) {
                                        $('#projectHashtags').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Please select country first</div>', html: true});
                                        $('#projectHashtags').popover('show');
                                        event.stopPropagation();
                                        return false;
                                    }

                                    // if(!ui.tagLabel.startsWith("#"))
                                    if(ui.tagLabel.indexOf("#") != 0)
                                    {
                                        $('#projectHashtags').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Hashtag is not valid, should begin with #!</div>', html: true});
                                        $('#projectHashtags').popover('show');
                                        event.stopPropagation();
                                        return false;
                                    }
                                    $('#projectHashtags').popover('destroy');
                                } 
                            }
                            return true;
                        },
                        onTagClicked: function (event, ui) {
                            var label = ui.tagLabel;
                            var DomainPatter = new RegExp(/^(?!:\/\/)([a-zA-Z0-9]+\.)?[a-zA-Z0-9-]+\.([a-zA-Z]{2,6}|[a-zA-Z]{2,6}.[a-zA-Z]{2,6})?$/i);
                            $('#projectKeywords').find('li').removeClass("active");
                            $('#projectUrls').find('li').removeClass("active");
                            $('#projectHashtags').find('li').removeClass("active");
                            ui.tag.addClass('active');

                            if(label.startsWith("#")){
                                $scope.handleOnTagClicked($scope.existsMentions, label);
                                
                            } else if(DomainPatter.test(label)) {
                                $scope.handleOnTagClicked($scope.existsMentions, label);
                                
                            } else {
                                $scope.handleOnTagClicked($scope.existsMentions, label);
                                
                            }
                        },
                        afterTagAdded: function (event, ui) {
                            var isNewTag = false;
                            var id = 0;
                            var label = ui.tagLabel;

                            var checkMentionAfterTagAddedParam = {
                                keyword: label,
                                countries: $scope.countryList
                            }

                            accountProjectsService.checkExistingMention(checkMentionAfterTagAddedParam, true)
                                .then(function(response) {
                                    var typeid = event.target.getAttribute("data-typeid");
                                    if (response.data.checkLanguage == -2) {
                                        if (typeid == 1) {
                                            $("#projectKeywords").tagit("removeTagByLabel", ui.tagLabel);
                                            $('#projectKeywords').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Only include Brand names when multiple coutries selected</div>', html: true});
                                            $('#projectKeywords').popover('show');
                                            event.stopPropagation();
                                            return false;
                                        } else if (typeid == 2) {
                                            $("#projectUrls").tagit("removeTagByLabel", ui.tagLabel);
                                            $('#projectUrls').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Only include Brand names when multiple coutries selected</div>', html: true});
                                            $('#projectUrls').popover('show');
                                            event.stopPropagation();
                                            return false;                              
                                        } else {
                                            $("#projectHashtags").tagit("removeTagByLabel", ui.tagLabel);
                                            $('#projectHashtags').popover({content: '<div class="text-danger" style="width: 200px;word-wrap:break-word;">Only include Brand names when multiple coutries selected</div>', html: true});
                                            $('#projectHashtags').popover('show');
                                            event.stopPropagation();
                                            return false;                                
                                        }
                                        return;
                                    }

                                    id = response.data.keyword.id;
                                    if (id == null) {
                                        isNewTag = true;
                                        newTagLabel = ui.tagLabel;
                                        if (newTagLabel.indexOf('\'') >= 0) {
                                            newTagLabel = newTagLabel.slice(0, newTagLabel.indexOf('\'')) + "\\" + newTagLabel.slice(newTagLabel.indexOf('\''));
                                        }
                                        var tempMention = {
                                            id: null,
                                            keywordType: typeid,
                                            keyword: newTagLabel
                                        }
                                    } else if (id > 0) {
                                        isNewTag = false;
                                        ui.tag.children(".tagit-label").get(0).text = response.data.keyword.keyword;
                                        $scope.languageList = [];
                                        angular.forEach(response.data.keyword.languages, function(language) {
                                            $scope.languageList.push(language.id);
                                        })
                                        var existMention = {
                                            id: response.data.keyword.id,
                                            keywordType: response.data.keyword.keywordType.id,
                                            keyword: response.data.keyword.keyword,
                                            languages: $scope.languageList,
                                            topic_id: response.data.keyword.topic[0].id,
                                            vertical_id: response.data.keyword.vertical[0].id
                                        }
                                        $scope.existsMentions.push(existMention);
                                    }

                                    if(isNewTag){
                                        $('#projectKeywords').find('li').removeClass("active");
                                        $('#projectUrls').find('li').removeClass("active");
                                        $('#projectHashtags').find('li').removeClass("active");
                                        ui.tag.addClass('active');

                                        // var newMention = $compile('<a class="unexisting" role="button" ng-click="unexistingClick(\'' + ui.tagLabel + '\', $event)">+ New Mention&nbsp;</a><img src="/images/question.gif" class="questionMention">')($scope);
                                        var newMention = $compile('<a class="unexisting" role="button" ng-click="unexistingClick(\'' + newTagLabel + '\', $event)">+ New Mention&nbsp;</a><img src="/images/question.gif" class="questionMention">')($scope);
                                        newMention.insertBefore(ui.tag.children().last());
                                    } else {
                                        if(response.data.keyword.approved == 2){
                                            var newMention = $compile('<span class="txt-waitapprove">+ Wait For Approve&nbsp;</span><img src="/images/question.gif" class="questionMention">')($scope);
                                            newMention.insertBefore(ui.tag.children().last());
                                        }
                                    }
                                }, function(response) {
                                    alert("We cannot get info about this keyword, please try again...")
                                    console.log(response.data);
                                })
                        },
                        beforeTagRemoved: function(event, ui) {
                            
                        },
                        afterTagRemoved: function (event, ui) {
                            var delteIndex = -1;
                            $scope.existsMentions.forEach(function(val){
                                if(val.keyword == ui.tagLabel){
                                    delteIndex = $scope.existsMentions.indexOf(val);
                                }
                            })
                            if(delteIndex != -1)
                            {
                                $scope.existsMentions.splice(delteIndex,1);
                            }
                        }
                    });

                    $scope.openCountryDropdownList = function () {
                        closeCountryDropdownList = false;
                    }

                    $scope.closeCountryDropdownList = function () {
                        closeCountryDropdownList = true;
                        if (closeCountryDropdownList == true) {
                            if ($scope.countryList == [] || $scope.countryList === undefined || $scope.countryList.length == 0) {
                                $('#projectKeywords').tagit("removeAll");
                                $('#projectUrls').tagit("removeAll");
                                $('#projectHashtags').tagit("removeAll");
                            }

                            $('#projectKeywords').popover('destroy');
                            $('#projectUrls').popover('destroy');
                            $('#projectHashtags').popover('destroy');

                            $scope.KeywordValidate = false;
                            $scope.temporaryMentions = [];
                            $scope.temporaryMentions.push($("#projectKeywords").tagit("assignedTags"));
                            $('#projectKeywords').tagit("removeAll");
                            angular.forEach($scope.temporaryMentions, function (temp) {
                                angular.forEach(temp, function (item) {
                                    $("#projectKeywords").tagit("createTag", item);
                                })
                            })
                            $scope.KeywordValidate = true;

                            $scope.KeywordValidate = false;
                            $scope.temporaryMentions = [];
                            $scope.temporaryMentions.push($("#projectUrls").tagit("assignedTags"));
                            $('#projectUrls').tagit("removeAll");
                            angular.forEach($scope.temporaryMentions, function (temp) {
                                angular.forEach(temp, function (item) {
                                    $("#projectUrls").tagit("createTag", item);
                                })
                            })
                            $scope.KeywordValidate = true;

                            $scope.KeywordValidate = false;
                            $scope.temporaryMentions = [];
                            $scope.temporaryMentions.push($("#projectHashtags").tagit("assignedTags"));
                            $('#projectHashtags').tagit("removeAll");
                            angular.forEach($scope.temporaryMentions, function (temp) {
                                angular.forEach(temp, function (item) {
                                    $("#projectHashtags").tagit("createTag", item);
                                })
                            })
                            $scope.KeywordValidate = true;
                            
                        }
                    }

                    $(".mentions").find('.tagit-new > input').on('focus', function(){
                        $('#projectKeywords').find('li').removeClass("active");
                        $('#projectUrls').find('li').removeClass("active");
                        $('#projectHashtags').find('li').removeClass("active");

                        $scope.mentionLanguage = 'Choose Language';
                        $scope.mentionTopic = 'Choose Topic';
                        $scope.mentionIndustry = 'Choose Industry';
//                        angular.forEach($scope.languages, function(language) {
//                            language.ticked = false;
//                        });

//                        angular.forEach($scope.topics, function(topic) {
//                            topic.ticked = false;
//                        });
//
//                        angular.forEach($scope.industries, function(industry) {
//                            industry.ticked = false;
//                        });
                        $scope.$apply();
                    });

                }, 500);

                $scope.backSpacePress = function(e){
                    if(e.keyCode == 8) {
                        var $activeElement = angular.element(document.activeElement.getElementsByClassName('active'));
                        if($activeElement.length > 0) {
                            var label = $activeElement[0].children[0].innerText;
                            var DomainPatter = new RegExp(/^(?!:\/\/)([a-zA-Z0-9]+\.)?[a-zA-Z0-9-]+\.([a-zA-Z]{2,6}|[a-zA-Z]{2,6}.[a-zA-Z]{2,6})?$/i);
                            if(label.startsWith("#")){
                                $("#projectHashtags").tagit("removeTagByLabel", label);
                                
                            } else if(DomainPatter.test(label)) {
                                $("#projectUrls").tagit("removeTagByLabel", label);
                                
                            } else {
                                $("#projectKeywords").tagit("removeTagByLabel", label);
                                
                            }  
                        }                    
                    }
                };

                $scope.getAccountInformation();
                $scope.getKeywordLanguages();
                $scope.getKeywordTopics();
                $scope.getKeywordIndustries();
            }
        ]);
})();